var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6652 8.70674C12.799 8.12576 11.9038 7.59144 10.9838 7.10306C11.4192 6.21435 11.8143 5.30582 12.1533 4.3729C12.5698 3.22659 12.9853 1.37461 11.7965 0.559643C10.398 -0.401004 9.38132 1.46206 8.70035 2.49626C8.0935 3.41585 7.53717 4.36905 7.02597 5.34554C5.58356 4.82358 4.10211 4.40885 2.59483 4.11132C1.84378 3.96244 0.83473 3.98069 0.562782 4.71757C0.301024 5.42392 0.986319 6.07577 1.58998 6.49075C2.83842 7.34999 4.09468 8.21151 5.37829 9.0217C4.7823 10.598 4.2998 12.2172 3.95429 13.8641C3.79245 14.6319 3.78948 15.6589 4.50785 15.9206C5.19645 16.1725 5.85111 15.4612 6.27135 14.8379C7.1299 13.5658 7.99037 12.2868 8.80461 10.9813C9.7608 11.4628 10.7383 11.9006 11.7493 12.2625C12.868 12.6634 14.6785 13.0465 15.5033 11.8202C16.4751 10.3759 14.6657 9.37928 13.6652 8.70674Z",
    fill: "#C4D086"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightStar);
export default __webpack_public_path__ + "static/media/light-star.5f8ad42e0fb252e8ec660f4c047e2039.svg";
export { ForwardRef as ReactComponent };